import { formatDate } from 'src/utils/formatDate';

import ArticleHero from 'components/BaseHelpers/ArticleHero';

import { ComponentProps } from '../../../types/component-props';
import { CoreNewsInsightsHeroData } from '../../../types/components';

export type CoreNewsInsightsHeroProps = ComponentProps & CoreNewsInsightsHeroData;

const CoreNewsInsightsHero = (props: CoreNewsInsightsHeroProps): JSX.Element => {
  const {
    breadcrumbs,
    contentTag,
    image = {
      src: 'https://dickinsonw-oniwp-l1.s3.amazonaws.com/wp-content/uploads/2026/06/23090119/News-and-Insights-3_2880x500-scaled.jpg',
      alt: 'News Insights Hero',
    },
    offices,
    subhead,
    title,
    cta,
    date,
    displayDate,
  } = props.fields;

  const formattedDate = displayDate || formatDate(date);

  return (
    <ArticleHero
      breadcrumbs={breadcrumbs}
      eyebrow={contentTag}
      image={image}
      links={offices}
      title={title}
      subhead={subhead}
      cta={cta}
      date={formattedDate}
    />
  );
};

export default CoreNewsInsightsHero;
